// extracted by mini-css-extract-plugin
module.exports = {"section":"DifferenceEmbeddedIPaaS_section__PaeIG","subject":"DifferenceEmbeddedIPaaS_subject__eBHMf","title":"DifferenceEmbeddedIPaaS_title__S496z"};